import React from "react";
import "../App.css";
import { Link } from "react-router-dom";

function Entry() {
  return (
    <div className="App">
      <div style={{ marginBottom: 10 }}>
        <p>TUMWABUDU MUNGU WETU</p>
      </div>
      <Link to="/verify">
        <button className="ui inverted primary button mini">Verify Now</button>
      </Link>
    </div>
  );
}

export default Entry;
